import { useTranslation } from "react-i18next";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  VStack,
  HStack,
  Divider,
} from "@chakra-ui/react";
import * as FiIcons from "react-icons/fi";
import theme from "../../../../../global/theme";

const GenericDeleteModal = ({ title, name, isLoading, onConfirm, onClose }) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <Modal isOpen={true} onClose={onClose} size="lg" dir={isRTL ? "rtl" : "ltr"}>
      <ModalOverlay />
      <ModalContent>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onConfirm();
          }}
        >
          <ModalHeader>{title}</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <VStack spacing={6} align="stretch">
              <HStack spacing={4} align="center">
                <Text color={theme.error}>
                  <FiIcons.FiAlertTriangle size={28} />
                </Text>
                <Text fontSize={14} fontWeight="500" color="#333">
                  {t("pages.role_management.delete_confirmation", { name: name || "-" })}
                </Text>
              </HStack>

              <Divider />

              <HStack justifyContent="flex-end" spacing={3}>
                <Button
                  type="button"
                  colorScheme="gray"
                  textTransform="capitalize"
                  onClick={onClose}
                >
                  {t("general.close")}
                </Button>
                <Button
                  type="submit"
                  bg={theme.error}
                  color="white"
                  textTransform="capitalize"
                  isLoading={isLoading}
                  _hover={{ opacity: 0.9 }}
                >
                  {t("general.delete")}
                </Button>
              </HStack>
            </VStack>
          </ModalBody>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default GenericDeleteModal;